import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaFacebookSquare, FaInstagram } from "react-icons/fa";
import { GrMapLocation } from "react-icons/gr";
import { FaWhatsapp, FaYoutube } from "react-icons/fa6";
import { MapPin, Mail, Smartphone } from "lucide-react";
import { toast } from "react-toastify";
import axios from "axios";
import { BASE_URL } from "../../constant";
import logo1 from "../../images/pbk.png";
import logo2 from "../../images/pbk2.png";
import wts from "../../images/whts.png";
import yt from "../../images/yt.png";
import insta from "../../images/insta.png";

const Footer = () => {
  const [activeTab, setActiveTab] = useState("About");
  const [emailSubscribedValue, setEmailSubscribedValue] = useState("");
  const [currentLogo, setCurrentLogo] = useState(logo2);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentLogo((prevLogo) => (prevLogo === logo1 ? logo2 : logo1));
  //   }, 2000);

  //   return () => clearInterval(interval);
  // }, []);

  const handleSubscribe = async () => {
    if (emailSubscribedValue.length < 10) {
      toast.error("Please enter a valid Mobile Number.");
      return;
    }

    const userId = localStorage.getItem("userId");
    if (userId) {
      try {
        const response = await axios.post(
          `${BASE_URL}/api/newsletter/join?email=${emailSubscribedValue}`
        );
        if (response.data === "Mobile No. already registered up.") {
          toast.info(response.data);
        } else {
          toast.success(response.data);
          setEmailSubscribedValue("");
        }
      } catch (error) {
        toast.error("Error subscribing to the Kharutaai");
      }
    } else {
      toast.error("Please signup first in order to Subscribe our Newsletter");
    }
  };

  const tabContent = {
    About: [{ to: "/sitemap", text: "Sitemap" }],
    Account: [
      { to: "/order-history", text: "Track Order" },
      { to: "/terms-of-use", text: "Terms of Use" },
    ],
    Policy: [
      { to: "/privacy-policy", text: "Privacy Policy" },
      { to: "/return-policy", text: "Return Policy" },
    ],
    Help: [
      { to: "/faqs", text: "FAQs" },
      { to: "/contact", text: "Get in Touch" },
    ],
  };

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-grid-container">
          <div className="footer-menu-container">
            <div className="footer-nav-menu">
              {Object.entries(tabContent).map(([category, links]) => (
                <div key={category}>
                  <h3 className="footer-h3">{category}</h3>
                  <ul>
                    {links.map((link, index) => (
                      <li key={index}>
                        <Link to={link.to} className="footer-menu-nav-link">
                          {link.text}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <div className="footer-bottom-link-container align-items-center">
              <Link to="/" className="footer-link-box">
                <div className="footer-btn-title">
                  <img
                    src={currentLogo}
                    alt="Logo"
                    style={{ height: "100px", width: "100px" }}
                  />
                </div>
              </Link>

              <Link to="/" className="footer-link-box">
                <div className="footer-btn-title">
                  <span>
                    {" "}
                    Kharutaai.
                    <br />
                    Formerly Known as <br />
                    “Prathamesh Balache Kapade”,
                  </span>
                </div>
              </Link>
            </div>
          </div>
          <div className="footer-newsletter align-items-start">
            <h2 className="footer-h2">BE THE FIRST TO KNOW</h2>
            <p className="p">
              Sign up to stay updated on new products, brand stories and events.
            </p>
            <div className="newsletter-input-container-div">
              <div className="newsletter-input-container">
                <input
                  type="text"
                  placeholder="Mobile Number"
                  className="newsletter-input"
                  value={emailSubscribedValue}
                  onChange={(e) => {
                    const newValue = e.target.value.replace(/[^0-9]/g, "");
                    setEmailSubscribedValue(newValue);
                  }}
                />
                <button className="newsletter-button" onClick={handleSubscribe}>
                  SUBSCRIBE
                </button>
              </div>
            </div>{" "}
            <Link
              to="https://maps.app.goo.gl/m8SZv"
              className="footer-link-box"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              <div className="footer-bottom-btn">
                <GrMapLocation size={40} className="footer-btn-icon" />
                <div className="footer-btn-title">
                  <span className="store-locator">Store Locator</span>
                </div>
              </div>
            </Link>
          </div>

          <div className="footer-nav-menu-mobile">
            <div className="d-flex align-items-center justify-content-start gap-3">
              {" "}
              <Link to="/">
                <div className="footer-btn-title">
                  <img
                    src={currentLogo}
                    alt="Logo"
                    style={{ height: "100px", width: "100px" }}
                  />
                </div>
              </Link>
              <Link to="/" style={{ color: "black", textDecoration: "none" }}>
                <div className="footer-btn-title">
                  <span style={{ color: "black", textDecoration: "none" }}>
                    {" "}
                    Kharutaai.
                    <br />
                    Brand of Kharutaai LLP.
                  </span>
                </div>
              </Link>
            </div>
            <div className="tab-headers">
              {Object.keys(tabContent).map((tab) => (
                <button
                  key={tab}
                  className={`tab-button ${activeTab === tab ? "tab-active" : ""
                    }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="tab-content">
              <ul>
                {tabContent[activeTab].map((link, index) => (
                  <li key={index}>
                    <Link to={link.to} className="footer-menu-nav-link">
                      {link.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="footer-contact-info">
            <div className="footer-contact-card-container">
              <div className="footer-contact-item">
                <span>
                  <MapPin size={25} />
                </span>
                <p className="contact-content">
                  <b>"Kharutaai"</b>
                  <br /> <b>
                    Formerly Known as “Prathamesh Balache Kapade”
                  </b>{" "}
                  <br /> Shop no. 05, Krishna Niwas, opp to TBZ Jewellers, near
                  Chitale Express, BCabin Road, Thane West 400602.
                </p>
              </div>
              <div className="footer-contact-item">
                <span>
                  <Mail size={25} />
                </span>
                <p className="contact-content">Connect@Kharutaai.com</p>
              </div>
              <div className="footer-contact-item">
                <span>
                  <Smartphone size={25} />
                </span>
                <p className="contact-content">+91 9833368284</p>
              </div>
            </div>
            <div className="footer-social-icons">
              <a
                href="https://www.instagram.com/kharutaai1999"
                className="social-icon"
                target="blank"
              >
                <img style={{ height: "20px", width: "20px" }} src={insta} />
              </a>
              <a
                href="https://wa.me/message/3OOU7LUIPQFDL1"
                className="social-icon"
                target="blank"
              >
                <img src={wts} />
              </a>
              <a
                href="https://youtube.com/@kharutaai"
                className="social-icon"
                target="blank"
              >
                <img src={yt} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
